
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { RiskLegendItem } from 'src/app/models/risk-config-legend.model';
import { trackByIndex } from 'src/app/shared/utils/track-by.util';

/**
 * Shared colour legend for jurisdiction risk-config bands (exposure likelihood levels, health risk
 * levels, %OEL bands). Extracted from the Jurisdiction Risk Config form so the Risk Assessment page
 * and the config page render an identical legend and cannot drift (DASH-3171).
 *
 * Dumb/presentational: callers pass pre-built {@link RiskLegendItem}s (colour + name + range string).
 * The colours and labels always originate from the tenant's jurisdiction risk config, never hardcoded.
 */
@Component({
    standalone: true,
    selector: 'app-risk-config-legend',
    imports: [TranslateModule],
    templateUrl: './risk-config-legend.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./risk-config-legend.component.scss']
})
export class RiskConfigLegendComponent {
    /** Optional heading shown above the legend (translated). */
    @Input() label = '';
    @Input() items: RiskLegendItem[] = [];

    readonly trackByIndex = trackByIndex;
}
